// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs-calculator .vs-calculator-input-group .vs-input-group{height:auto;margin-bottom:20px}.vs-calculator .vs-currency-dropdown-right .vs-listbox{left:auto;right:0}@media(min-width:992px){.vs-calculator .vs-currency-dropdown-right .vs-listbox{left:0;right:auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
